import { all, take, race, put, delay } from 'redux-saga/effects';
import { createAsyncSaga } from '../cores/createAsyncSaga';
import { DealerActions } from '../store/dealer';

export default function* rootSaga() {
  yield all([...createAsyncSaga(DealerActions)]);
}
